document.addEventListener('DOMContentLoaded', () => {
  // --- 1. Countdown Timer ---
  const initCountdown = () => {
    const hrsEl = document.getElementById('timer-hrs');
    const minsEl = document.getElementById('timer-mins');
    const secsEl = document.getElementById('timer-secs');

    if (!hrsEl || !minsEl || !secsEl) return;

    // Set initial countdown time: 2 hours, 14 minutes, 36 seconds
    let totalSeconds = (2 * 3600) + (14 * 60) + 36;

    const updateTimerDisplay = () => {
      if (totalSeconds <= 0) {
        // Reset countdown to maintain urgency
        totalSeconds = (2 * 3600) + (14 * 60) + 36;
      }

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      hrsEl.textContent = String(hours).padStart(2, '0');
      minsEl.textContent = String(minutes).padStart(2, '0');
      secsEl.textContent = String(seconds).padStart(2, '0');

      totalSeconds--;
    };

    updateTimerDisplay();
    setInterval(updateTimerDisplay, 1000);
  };

  // --- 2. Dynamic Stock Meter Scarcity ---
  const initStockMeter = () => {
    const stockFill = document.querySelector('.scarcity-meter-fill');
    const stockCountEl = document.querySelector('.scarcity-title span'); // Expects e.g. "Only 28 jars left in stock!"

    if (!stockFill) return;

    let stockLeft = 28;
    const maxStock = 200; // Simulating max inventory to calculate width

    const updateStockDisplay = () => {
      // Calculate percentage width (e.g. 28/200 = 14%)
      const percentage = (stockLeft / maxStock) * 100;
      stockFill.style.width = `${Math.max(percentage, 5)}%`; // Keep a minimum width so it doesn't disappear

      if (stockCountEl) {
        stockCountEl.textContent = `${stockLeft} jars`;
      }
    };

    updateStockDisplay();

    // Decrement stock occasionally to simulate live purchases
    const interval = setInterval(() => {
      if (stockLeft > 3) {
        // Random decrement between 1 and 2
        stockLeft -= Math.floor(Math.random() * 2) + 1;
        updateStockDisplay();
      } else {
        clearInterval(interval);
      }
    }, 45000); // Check every 45 seconds
  };

  // --- 3. Pricing Cards Option Selector ---
  const initPricingSelector = () => {
    const cards = document.querySelectorAll('.pricing-card');

    cards.forEach(card => {
      card.addEventListener('click', () => {
        // Remove selected class from all cards
        cards.forEach(c => c.classList.remove('selected'));

        // Add selected class to the clicked card
        card.classList.add('selected');

        // Fetch selected package info
        const packageType = card.getAttribute('data-package');
        const price = card.getAttribute('data-price');

        // Log selection for debug
        console.log(`Selected package: ${packageType} - ₹${price}`);

        // If Shopify cart integration is needed:
        // Update a hidden variant input inside a form, or update the bottom sticky CTA link/price
        const stickyCtaBuyBtn = document.querySelector('.sticky-cta-bar .btn-gold');
        if (stickyCtaBuyBtn) {
          const discountInfo = packageType === '3-bottles' ? 'Get Flat ₹200 Off (Prepaid)' : 'Get Flat ₹100 Off (Prepaid)';
          stickyCtaBuyBtn.innerHTML = `
            <svg viewBox="0 0 24 24"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>
            BUY NOW
            <span class="subtext">${discountInfo}</span>
          `;

          // Set dynamic redirect/cart URL
          const variantId = card.getAttribute('data-variant-id');
          if (variantId) {
            stickyCtaBuyBtn.setAttribute('href', `/cart/add?id=${variantId}&quantity=1`);
          }
        }
      });
    });
  };

  // --- 4. Video Modal Popup ---
  const initVideoModal = () => {
    const videoTriggers = document.querySelectorAll('.video-overlay-play, .video-thumb-play, .video-list-card');
    const modal = document.getElementById('video-modal');
    const iframe = document.getElementById('video-iframe');
    const closeBtn = document.getElementById('video-close');

    if (!modal || !iframe || !closeBtn) return;

    // Direct YouTube embed URLs matching the context
    const videoUrls = {
      'expert': 'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1', // Placeholder or real testimonial video
      'video1': 'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1',
      'video2': 'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1'
    };

    videoTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const type = trigger.getAttribute('data-video-type') || 'expert';
        const url = videoUrls[type] || videoUrls['expert'];

        iframe.setAttribute('src', url);
        modal.classList.add('active');
        document.body.style.overflow = 'hidden'; // Stop background scrolling
      });
    });

    const closeModal = () => {
      modal.classList.remove('active');
      iframe.setAttribute('src', '');
      document.body.style.overflow = '';
    };

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });
  };

  // --- 5. Smooth Scroll CTAs ---
  const initSmoothScroll = () => {
    const scrollTriggers = document.querySelectorAll('a[href^="#"]');
    scrollTriggers.forEach(trigger => {
      trigger.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const targetEl = document.querySelector(targetId);
        if (targetEl) {
          e.preventDefault();
          targetEl.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  };

  // --- 6. Navigation Drawer Toggle ---
  const initNavigationDrawer = () => {
    const hamburgerBtn = document.querySelector('.header-hamburger');
    const closeBtn = document.getElementById('MenuDrawerClose');
    const overlay = document.getElementById('MenuDrawerOverlay');
    const drawer = document.getElementById('MenuDrawer');
    const drawerLinks = document.querySelectorAll('.menu-drawer-link, .menu-drawer-btn');

    if (!hamburgerBtn || !drawer) return;

    const openDrawer = () => {
      drawer.classList.add('active');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent background scroll
    };

    const closeDrawer = () => {
      drawer.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore scroll
    };

    hamburgerBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Close drawer when a link is clicked
    drawerLinks.forEach(link => {
      link.addEventListener('click', () => {
        closeDrawer();
      });
    });
  };

  // --- 7. Expert Carousel Slider ---
  const initExpertCarousel = () => {
    const carousels = document.querySelectorAll('.expert-carousel-wrapper');
    carousels.forEach(wrapper => {
      const carousel = wrapper.querySelector('.expert-carousel');
      const slides = carousel.querySelectorAll('.expert-slide');
      const dots = wrapper.querySelectorAll('.carousel-dot');
      if (slides.length <= 1) return;

      let currentIndex = 0;
      let intervalId = null;

      const goToSlide = (index) => {
        slides.forEach((slide, idx) => {
          slide.classList.remove('active');
          if (dots[idx]) dots[idx].classList.remove('active');
        });
        slides[index].classList.add('active');
        if (dots[index]) dots[index].classList.add('active');
        currentIndex = index;
      };

      const startAutoPlay = () => {
        intervalId = setInterval(() => {
          let nextIndex = (currentIndex + 1) % slides.length;
          goToSlide(nextIndex);
        }, 5000);
      };

      const stopAutoPlay = () => {
        if (intervalId) clearInterval(intervalId);
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          stopAutoPlay();
          goToSlide(index);
          startAutoPlay();
        });
      });

      startAutoPlay();
    });
  };

  // --- 8. Dynamic Sales Counter ---
  const initSalesCounter = () => {
    const counterEl = document.getElementById('sold-counter');
    if (!counterEl) return;

    const baseVal = 30135;
    const incrementPerMinute = 1;

    let currentVal = baseVal;
    const now = Date.now();

    let storedVal = localStorage.getItem('sales_counter_val');
    let storedTime = localStorage.getItem('sales_counter_time');

    if (storedVal && storedTime) {
      const elapsedMinutes = Math.floor((now - parseInt(storedTime)) / 60000);
      if (elapsedMinutes > 0) {
        currentVal = parseInt(storedVal) + (elapsedMinutes * incrementPerMinute);
      } else {
        currentVal = parseInt(storedVal);
      }
    } else {
      currentVal = baseVal;
    }

    localStorage.setItem('sales_counter_val', currentVal);
    localStorage.setItem('sales_counter_time', now);

    const updateDisplay = () => {
      counterEl.textContent = `${currentVal.toLocaleString()}+`;
    };

    updateDisplay();

    setInterval(() => {
      currentVal += 1;
      localStorage.setItem('sales_counter_val', currentVal);
      localStorage.setItem('sales_counter_time', Date.now());
      updateDisplay();
    }, 60000);
  };

  // Initialize all functions
  initCountdown();
  initStockMeter();
  initPricingSelector();
  initVideoModal();
  initSmoothScroll();
  initNavigationDrawer();
  initExpertCarousel();
  initSalesCounter();
});